// @flow
export { default } from './EventTags';



// WEBPACK FOOTER //
// ./src/components/event/EventTags/index.js